export const createUrl = (url) => `${process.env.REACT_APP_API_URL}/${url}`;
export const createCssUrl = (url) => `url(${process.env.REACT_APP_API_URL}${url})`;
export const createUploadUrl = (url) => `${process.env.REACT_APP_API_URL}${url}`;
